import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../services/base/authentication.service';

@Component({
  selector: 'fury-toolbar-user-availability',
  templateUrl: './toolbar-user-availability.component.html',
  styleUrls: ['./toolbar-user-availability.component.scss']
})
export class ToolbarUserAvailabilityComponent implements OnInit {

  constructor(
    public authenticationService: AuthenticationService,
  ) {
  }

  ngOnInit(): void {
  }
}
